import Vue from 'vue'
import Vuex from 'vuex'

import AuthenticationModule from '@/store/authentication'
import ContactModule from '@/store/contact'
import PermissionsModule from '@/store/permissions'
import ProfilesModule from '@/store/profiles'
import UsersModule from '@/store/users'
import NotificationsModule from '@/store/notifications'
import ServicesModule from '@/store/services'
import ConfigurationModule from '@/store/configuration'
import PropertyModule from '@/store/property'
import LanguageModule from '@/store/language'
import CompanyModule from '@/store/company'
import ZoneModule from '@/store/zone'
import ControlPointModule from '@/store/control_point'
import VisitedModule from '@/store/visited'
import AuthorizedTypeModule from '@/store/authorized_type'
import HolidayModule from '@/store/holiday'
import NoveltyModule from '@/store/novelty'
import AuthorizationModule from '@/store/authorization'
import DocumentModule from '@/store/document'
import CredentialModule from '@/store/credential'
import AccessDay from '@/store/access_day'
import LogModule from '@/store/logs'
import ReceptionModule from '@/store/reception'
import DepartmentModule from '@/store/department'
import AccessProfileModule from '@/store/access_profile'
import SiteModule from '@/store/site'
import NetworkModule from '@/store/network'
import ReloadModule from '@/store/reload'
import SupportModule from '@/store/support'
import UpdateModule from '@/store/update'
import ReportModule from '@/store/report'
import SyncModule from '@/store/sync'
import RestoreModule from '@/store/restore'
import HomeModule from '@/store/home'
import BackupModule from '@/store/backup'
import BlockadeModule from '@/store/blockade'
import ManufacturerModule from '@/store/manufacturer'
import CameraModule from '@/store/camera'
import TraficBoardModule from '@/store/trafic_board'
import AdvanceSerach from '@/store/advance_search'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    authentication: AuthenticationModule,
    contact: ContactModule,
    permissions: PermissionsModule,
    profiles: ProfilesModule,
    users: UsersModule,
    notifications: NotificationsModule,
    services: ServicesModule,
    configuration: ConfigurationModule,
    property: PropertyModule,
    language: LanguageModule,
    company: CompanyModule,
    zone: ZoneModule,
    control_point: ControlPointModule,
    visited: VisitedModule,
    authorized_type: AuthorizedTypeModule,
    holiday: HolidayModule,
    document: DocumentModule,
    credential: CredentialModule,
    access_day: AccessDay,
    log: LogModule,
    novelty: NoveltyModule,
    authorization: AuthorizationModule,
    reception: ReceptionModule,
    department: DepartmentModule,
    access_profile: AccessProfileModule,
    site: SiteModule,
    network: NetworkModule,
    reload: ReloadModule,
    support: SupportModule,
    update: UpdateModule,
    report: ReportModule,
    sync: SyncModule,
    restore: RestoreModule,
    home: HomeModule,
    backup: BackupModule,
    blockade: BlockadeModule,
    manufacturer: ManufacturerModule,
    camera: CameraModule,
    trafic_board: TraficBoardModule,
    advance_search: AdvanceSerach
  }
})

export default store



// WEBPACK FOOTER //
// app/javascript/src/store/store.js